import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import { ChatPanel } from "./ChatPanel";

const mockCancelStream = jest.fn(async () => undefined);
let mockChatState: Record<string, unknown> = {};

jest.mock("@metalmind-ab/mmagent-chat-ui/styles.css", () => ({}), {
  virtual: true,
});
jest.mock("@metalmind-ab/mmagent-chat-ui", () => {
  const actual = jest.requireActual("@metalmind-ab/mmagent-chat-ui");
  return {
    ...actual,
    useChat: () => ({
      messages: [],
      sendMessage: jest.fn(),
      cancelStream: mockCancelStream,
      isLoading: true,
      isStopping: false,
      stopError: null,
      ...mockChatState,
    }),
  };
});
jest.mock("../../../../hooks/useAuthHeaders", () => ({
  useAuthHeaders: () => async () => ({ Authorization: "test-token" }),
}));
jest.mock("../../../../hooks/useChatImageAttachments", () => ({
  useChatImageAttachments: () => ({ enabled: false, uploadImage: jest.fn() }),
}));
jest.mock("../../../../config/runtimeConfig", () => ({
  getApiBaseUrl: () => "http://localhost",
}));
jest.mock("../../../../utils/chatResumeOptions", () => ({
  buildChatResumeOptions: () => ({}),
}));

const originalFetch = global.fetch;

beforeEach(() => {
  mockCancelStream.mockClear();
  mockChatState = {};
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  global.fetch = jest.fn(
    async () =>
      ({ ok: true, json: async () => ({ items: [], total: 0 }) }) as Response,
  ) as unknown as typeof fetch;
});

afterEach(() => {
  global.fetch = originalFetch;
});

const findStopButton = (name: RegExp) => screen.findByRole("button", { name });

it("asks the package to stop the run when Stop is clicked", async () => {
  render(<ChatPanel workspaceId="workspace-1" />);

  const stop = await findStopButton(/stop generating/i);
  fireEvent.click(stop);

  expect(mockCancelStream).toHaveBeenCalledTimes(1);
  expect(stop).toBeEnabled();
});

it("disables Stop while the server has not confirmed it yet", async () => {
  mockChatState = { isStopping: true };
  render(<ChatPanel workspaceId="workspace-1" />);

  expect(await findStopButton(/stopping/i)).toBeDisabled();
});

it("tells the user when the server did not confirm Stop, and keeps Stop available", async () => {
  mockChatState = {
    stopError: "Only the originating requester may stop this execution.",
  };
  render(<ChatPanel workspaceId="workspace-1" />);

  expect(
    await screen.findByText(
      "Only the originating requester may stop this execution.",
    ),
  ).toBeInTheDocument();
  expect(await findStopButton(/stop generating/i)).toBeEnabled();
});
